document.addEventListener("DOMContentLoaded", function () {
  // COSTANTI E CONFIGURAZIONE INIZIALE
  var tileSizeMeters = 0.4;
  var margin = 1.05; // usato per calcolare le "piastrelle consigliate"
  var maxGridSizePx = 700;
  var assetMap = {
    arancione: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_arancione.png",
    bianco: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_bianco.png",
    blu: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_blu.png",
    giallo: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_giallo.png",
    grigio: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_grigio.png",
    nero: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_nero.png",
    rosso: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_rosso.png",
    verde: "https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/Piastrella_verde.png"
  };

  // Mapping varianti (GID GraphQL) per ciascun colore
  var variantMapping = {
    nero: "gid://shopify/ProductVariant/55162978926966",
    grigio: "gid://shopify/ProductVariant/55162978959734",
    verde: "gid://shopify/ProductVariant/55162979025270",
    blu: "gid://shopify/ProductVariant/55162979058038",
    bianco: "gid://shopify/ProductVariant/55162979090806",
    rosso: "gid://shopify/ProductVariant/55162979156342",
    arancione: "gid://shopify/ProductVariant/55162979189110",
    giallo: "gid://shopify/ProductVariant/55162979221878"
  };

  // Variabili di stato del configuratore
  var activeColor = "rosso";
  var isErasing = false;
  var isDrawing = false;
  var drawEnabled = true;
  var gridColors = [];

  // Funzione helper: carica un'immagine e la converte in base64
  function loadImageAsBase64(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  // Inserisci la struttura HTML (inclusa la card contenente riepilogo e bottoni)
  var plannerUI = document.getElementById("planner-ui");
  plannerUI.innerHTML = '\
    <div id="planner-inner">\
      <div class="form-row">\
        <div class="form-group">\
          <label for="widthInput">Larghezza stanza (m)</label>\
          <input type="number" id="widthInput" value="4" step="0.1">\
        </div>\
        <div class="form-group">\
          <label for="lengthInput">Lunghezza stanza (m)</label>\
          <input type="number" id="lengthInput" value="3" step="0.1">\
        </div>\
        <div class="form-group">\
          <label for="patternSelect">Pattern</label>\
          <select id="patternSelect">\
            <option value="solid">Tinta Unita</option>\
            <option value="checkerboard">Scacchiera</option>\
            <option value="border">Bordo</option>\
            <option value="mosaic">Mosaico</option>\
            <option value="custom">Personalizzato</option>\
          </select>\
        </div>\
      </div>\
      <div class="form-row">\
        <div class="form-group" id="borderSizeWrapper">\
          <label for="borderSizeInput">Spessore bordo</label>\
          <input type="number" id="borderSizeInput" value="1" min="1">\
        </div>\
        <div class="form-group" id="mosaicToggle">\
          <label><input type="checkbox" id="amplifyMosaic"> Amplifica mosaico (4x4)</label>\
        </div>\
        <div class="form-group" id="color1Wrapper">\
          <label for="color1Select">Colore 1</label>\
          <select id="color1Select"></select>\
        </div>\
        <div class="form-group" id="color2Wrapper">\
          <label for="color2Select">Colore 2</label>\
          <select id="color2Select"></select>\
        </div>\
      </div>\
      <div id="customTools" style="display:none; text-align: center;">\
        <div id="colorPalette" style="margin-bottom:15px; display:flex; flex-wrap:wrap; gap:10px; justify-content:center;"></div>\
        <button id="fillBtn">🪣 Riempi</button>\
        <button id="eraserBtn">🧽 Gomma</button>\
        <button id="resetBtn">🔄 Reset</button>\
        <button id="toggleDrawBtn" class="mobile-only">✍️ Disegno: ON</button>\
      </div>\
      <div id="zoom-controls" style="text-align:center; margin-bottom: 10px;">\
        <button id="zoomOutBtn" style="padding:6px 10px; font-size:18px;">🔍➖</button>\
        <button id="zoomInBtn" style="padding:6px 10px; font-size:18px;">🔍➕</button>\
      </div>\
      <div id="grid-wrapper"><div id="grid"></div></div>\
      <div id="results"></div>\
      <div id="priceCard" class="price-card">\
        <div id="priceSummary"></div>\
        <button id="addCartBtn" class="warehouse-btn">Aggiungi al carrello</button>\
        <button id="downloadPdfBtn" class="warehouse-btn" style="margin-top:10px; background-color: #ccc; color: #000;">Scarica il PDF</button>\
      </div>\
    </div>';

  // Selettori ed elementi (tutti gli elementi ora devono essere presenti)
  var widthInput = document.getElementById("widthInput"),
      lengthInput = document.getElementById("lengthInput"),
      patternSelect = document.getElementById("patternSelect"),
      amplifyMosaic = document.getElementById("amplifyMosaic"),
      borderSizeInput = document.getElementById("borderSizeInput"),
      mosaicToggle = document.getElementById("mosaicToggle"),
      color1Select = document.getElementById("color1Select"),
      color2Select = document.getElementById("color2Select"),
      color1Wrapper = document.getElementById("color1Wrapper"),
      color2Wrapper = document.getElementById("color2Wrapper"),
      borderSizeWrapper = document.getElementById("borderSizeWrapper"),
      colorPalette = document.getElementById("colorPalette"),
      fillBtn = document.getElementById("fillBtn"),
      resetBtn = document.getElementById("resetBtn"),
      eraserBtn = document.getElementById("eraserBtn"),
      toggleDrawBtn = document.getElementById("toggleDrawBtn"),
      grid = document.getElementById("grid"),
      results = document.getElementById("results"),
      priceSummary = document.getElementById("priceSummary"),
      addCartBtn = document.getElementById("addCartBtn"),
      downloadPdfBtn = document.getElementById("downloadPdfBtn");

   // Imposta il valore massimo per i campi di dimensione
  widthInput.setAttribute("max", "40");
  lengthInput.setAttribute("max", "40");

  widthInput.addEventListener("input", function () {
    if (parseFloat(widthInput.value) > 40) {
      widthInput.value = 40;
    }
  });
  lengthInput.addEventListener("input", function () {
    if (parseFloat(lengthInput.value) > 40) {
      lengthInput.value = 40;
    }
  });

  // Stile per il tasto "Aggiungi al carrello"
  addCartBtn.style.backgroundColor = "#CB1836";
  addCartBtn.style.color = "#fff";

  // Gestione del tasto "Disegno"
  toggleDrawBtn.addEventListener("click", function () {
    drawEnabled = !drawEnabled;
    toggleDrawBtn.textContent = "✍️ Disegno: " + (drawEnabled ? "ON" : "OFF");
    renderGrid();
  });

  // Setup dei selector per i colori
  var setupSelectors = function () {
    [color1Select, color2Select].forEach(function (select) {
      select.innerHTML = "";
      for (var key in assetMap) {
        if (assetMap.hasOwnProperty(key)) {
          var opt = new Option(key, key);
          select.appendChild(opt);
        }
      }
    });
    color1Select.value = "rosso";
    color2Select.value = "bianco";
  };

  // Inizializza la griglia per il pattern "custom"
  var setupGrid = function (cols, rows) {
    gridColors = [];
    for (var i = 0; i < rows; i++) {
      var row = [];
      for (var j = 0; j < cols; j++) {
        row.push("bianco");
      }
      gridColors.push(row);
    }
  };

  // Funzione per determinare il colore in base al pattern selezionato
  var getPatternColor = function (x, y, cols, rows) {
    var p = patternSelect.value,
        c1 = color1Select.value,
        c2 = color2Select.value,
        block = amplifyMosaic.checked ? 4 : 2,
        border = parseInt(borderSizeInput.value, 10);
    if (p === "solid") return c1;
    if (p === "checkerboard") return (x + y) % 2 === 0 ? c1 : c2;
    if (p === "border") return (x < border || y < border || x >= cols - border || y >= rows - border) ? c1 : c2;
    if (p === "mosaic") return (Math.floor(x / block) + Math.floor(y / block)) % 2 === 0 ? c1 : c2;
    return gridColors[y][x];
  };

  // Renderizza la palette dei colori
  var renderPalette = function () {
    colorPalette.innerHTML = "";
    for (var color in assetMap) {
      if (assetMap.hasOwnProperty(color)) {
        var btn = document.createElement("button");
        btn.style.backgroundImage = "url(" + assetMap[color] + ")";
        btn.className = activeColor === color && !isErasing ? "active" : "";
        btn.onclick = (function (col) {
          return function () {
            activeColor = col;
            isErasing = false;
            renderPalette();
          };
        })(color);
        colorPalette.appendChild(btn);
      }
    }
  };

  var zoomLevel = 1;
  // Renderizza la griglia e aggiorna i risultati
  var renderGrid = function () {
    var width = parseFloat(widthInput.value),
        height = parseFloat(lengthInput.value),
        cols = Math.ceil(width / tileSizeMeters),
        rows = Math.ceil(height / tileSizeMeters),
        tileSize = Math.floor(Math.min(maxGridSizePx / cols, maxGridSizePx / rows) * zoomLevel),
        pattern = patternSelect.value;
    if (pattern === "custom" && (gridColors.length !== rows || (gridColors[0] && gridColors[0].length !== cols))) {
      setupGrid(cols, rows);
    }
    grid.innerHTML = "";
    grid.style.gridTemplateColumns = "repeat(" + cols + ", " + tileSize + "px)";
    grid.style.pointerEvents = (pattern === "custom" && !drawEnabled) ? "none" : "auto";
    var i, x, y, color, tile;
    for (y = 0; y < rows; y++) {
      for (x = 0; x < cols; x++) {
        color = getPatternColor(x, y, cols, rows);
        tile = document.createElement("div");
        tile.className = "tile";
        tile.style.width = tile.style.height = tileSize + "px";
        tile.style.backgroundImage = "url(" + assetMap[color] + ")";
        if (pattern === "custom") {
          (function (x, y, tile) {
            var draw = function () {
              if (!drawEnabled) return;
              gridColors[y][x] = isErasing ? "bianco" : activeColor;
              tile.style.backgroundImage = "url(" + assetMap[gridColors[y][x]] + ")";
              updateResults();
            };
            tile.addEventListener("mousedown", function (e) {
              e.preventDefault();
              isDrawing = true;
              draw();
            });
            tile.addEventListener("mouseenter", function () {
              if (isDrawing) { draw(); }
            });
            tile.addEventListener("touchstart", function (e) {
              e.preventDefault();
              isDrawing = true;
              draw();
            });
            tile.addEventListener("touchmove", function (e) {
              e.preventDefault();
              var touch = e.touches[0],
                  target = document.elementFromPoint(touch.clientX, touch.clientY);
              if (target && target.classList.contains("tile")) {
                var index = Array.prototype.indexOf.call(grid.children, target),
                    tx = index % gridColors[0].length,
                    ty = Math.floor(index / gridColors[0].length);
                gridColors[ty][tx] = isErasing ? "bianco" : activeColor;
                target.style.backgroundImage = "url(" + assetMap[gridColors[ty][tx]] + ")";
                updateResults();
              }
            });
          })(x, y, tile);
        }
        grid.appendChild(tile);
      }
    }
    updateResults();
  };

  // Calcola il numero esatto di piastrelle per colore
  var calculateTileCounts = function () {
    var width = parseFloat(widthInput.value),
        height = parseFloat(lengthInput.value),
        cols = Math.ceil(width / tileSizeMeters),
        rows = Math.ceil(height / tileSizeMeters),
        totalTiles = cols * rows,
        pattern = patternSelect.value,
        count = {},
        source = [],
        i, x, y, c;
    if (pattern === "custom") {
      for (y = 0; y < rows; y++) {
        for (x = 0; x < cols; x++) {
          source.push(gridColors[y][x]);
        }
      }
    } else {
      for (i = 0; i < totalTiles; i++) {
        x = i % cols;
        y = Math.floor(i / cols);
        source.push(getPatternColor(x, y, cols, rows));
      }
    }
    for (i = 0; i < source.length; i++) {
      c = source[i];
      count[c] = count[c] ? count[c] + 1 : 1;
    }
    return count;
  };

  // Aggiorna i risultati visuali e il riepilogo prezzo
  var updateResults = function () {
    var width = parseFloat(widthInput.value),
        height = parseFloat(lengthInput.value),
        cols = Math.ceil(width / tileSizeMeters),
        rows = Math.ceil(height / tileSizeMeters),
        totalTiles = cols * rows,
        recommendedTiles = Math.ceil(totalTiles * margin),
        count = calculateTileCounts();
    results.innerHTML = "<p><strong>Superficie stanza:</strong> " + (width * height).toFixed(2) + " m²</p>" +
                        "<p><strong>Piastrelle visualizzate:</strong> " + totalTiles + "</p>" +
                        "<p><strong>Piastrelle consigliate (+5%):</strong> " + recommendedTiles + "</p>" +
                        "<ul>" + Object.keys(count).map(function(col) {
                          return "<li>" + col.toUpperCase() + ": " + count[col] + "</li>";
                        }).join("") + "</ul>";
    updatePriceSummary();
  };

  // Calcola e aggiorna il riepilogo prezzo
  var updatePriceSummary = function () {
    var counts = calculateTileCounts(),
        totalTiles = 0;
    for (var col in counts) {
      if (counts.hasOwnProperty(col)) {
        totalTiles += counts[col];
      }
    }
    var basePrice = totalTiles * 5,
        discountRate = 0;
    if (totalTiles >= 1000) {
      discountRate = 0.20;
    } else if (totalTiles >= 500) {
      discountRate = 0.15;
    } else if (totalTiles >= 200) {
      discountRate = 0.10;
    } else if (totalTiles >= 100) {
      discountRate = 0.05;
    }
    var discountedPrice = basePrice * (1 - discountRate);
    priceSummary.innerHTML = "<p><strong>Riepilogo Prezzo</strong></p>" +
                             "<p>Totale piastrelle: " + totalTiles + "</p>" +
                             "<p>Prezzo base: €" + basePrice.toFixed(2) + "</p>" +
                             "<p>Sconto applicato: " + (discountRate * 100) + "%</p>" +
                             "<p><strong>Totale finale: €" + discountedPrice.toFixed(2) + "</strong></p>";
  };

  // Gestione dei bottoni "Riempi", "Reset" e "Gomma"
  fillBtn.onclick = function () {
    var cols = gridColors[0].length,
        rows = gridColors.length;
    for (var i = 0; i < rows; i++) {
      for (var j = 0; j < cols; j++) {
        gridColors[i][j] = activeColor;
      }
    }
    renderGrid();
  };
  resetBtn.onclick = function () {
    var cols = Math.ceil(parseFloat(widthInput.value) / tileSizeMeters),
        rows = Math.ceil(parseFloat(lengthInput.value) / tileSizeMeters);
    setupGrid(cols, rows);
    renderGrid();
  };
  eraserBtn.onclick = function () {
    isErasing = true;
    renderPalette();
  };
  document.addEventListener("mouseup", function () { isDrawing = false; });
  document.addEventListener("touchend", function () { isDrawing = false; });
  [widthInput, lengthInput, patternSelect, color1Select, color2Select, amplifyMosaic, borderSizeInput].forEach(function (el) {
    el.addEventListener("input", function () {
      customTools.style.display = (patternSelect.value === "custom") ? "block" : "none";
      mosaicToggle.style.display = (patternSelect.value === "mosaic") ? "block" : "none";
      borderSizeWrapper.style.display = (patternSelect.value === "border") ? "block" : "none";
      color1Wrapper.style.display = (["solid", "checkerboard", "border", "mosaic"].indexOf(patternSelect.value) !== -1) ? "block" : "none";
      color2Wrapper.style.display = (["checkerboard", "border", "mosaic"].indexOf(patternSelect.value) !== -1) ? "block" : "none";
      renderPalette();
      renderGrid();
    });
  });
  setupSelectors();
  renderPalette();
  renderGrid();
  patternSelect.dispatchEvent(new Event("input"));
  document.getElementById("zoomInBtn").addEventListener("click", function () {
    zoomLevel = Math.min(zoomLevel + 0.1, 2);
    renderGrid();
  });
  document.getElementById("zoomOutBtn").addEventListener("click", function () {
    zoomLevel = Math.max(zoomLevel - 0.1, 0.3);
    renderGrid();
  });

  // ================================
  // FUNZIONALITÀ "AGGIUNGI AL CARRELLO" CON CONTROLLO DISPONIBILITÀ E REINDIRIZZAMENTO
  // ================================
  var extractNumericId = function(gid) {
    var parts = gid.split("/");
    return parts[parts.length - 1];
  };

  var addToCart = function () {
    var counts = calculateTileCounts();
    var itemsToAdd = [];
    var shortageMessages = [];
    var hasTiles = false;
    for (var col in counts) {
      if (counts.hasOwnProperty(col) && counts[col] > 0) {
        hasTiles = true;
        break;
      }
    }
    if (!hasTiles) {
      alert("Non hai selezionato alcuna piastrella!");
      return;
    }
    fetch("https://ws-italy.myshopify.com/api/2023-10/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "9da49c1f4b3e34a2870426efd52619d9"
      },
      body: JSON.stringify({
        query: '\
          {\
            productByHandle(handle: "piastrelle-da-officina-40cm-x-40xm-spessore-18mm") {\
              title\
              variants(first: 100) {\
                edges {\
                  node {\
                    id\
                    title\
                    quantityAvailable\
                  }\
                }\
              }\
            }\
          }'
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var product = data.data && data.data.productByHandle;
      if (!product) {
        alert("❌ Prodotto non trovato o handle errato");
        return;
      }
      var inventoryMap = {};
      var variants = product.variants.edges.map(function (edge) {
        return edge.node;
      });
      for (var i = 0; i < variants.length; i++) {
        inventoryMap[variants[i].id] = variants[i].quantityAvailable;
      }
      for (var color in counts) {
        if (counts.hasOwnProperty(color)) {
          var qty = counts[color];
          var variantId = variantMapping[color];
          var numericVariantId = extractNumericId(variantId);
          var available = inventoryMap[variantId];
          if (typeof available === "undefined") {
            console.warn("Nessuna informazione di disponibilità per il colore: " + color);
            continue;
          }
          if (qty > available) {
            shortageMessages.push("nella tua composizione ci sono " + qty + " piastrelle " + color + ", al momento ne abbiamo disponibili " + available);
            itemsToAdd.push({ id: numericVariantId, quantity: available });
          } else {
            itemsToAdd.push({ id: numericVariantId, quantity: qty });
          }
        }
      }
      if (itemsToAdd.length === 0) {
        alert("Nessun prodotto valido da aggiungere al carrello.");
        return;
      }
      if (shortageMessages.length > 0) {
        var message = "Attenzione, " + shortageMessages.join(" e ") + ".\nVuoi comunque aggiungere quelle disponibili al carrello e procedere?\nContattaci a info@workshopitaly.net per conoscere le tempistiche di spedizione delle piastrelle mancanti.";
        if (!window.confirm(message)) return;
      }
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ items: itemsToAdd }),
        dataType: "json",
        contentType: "application/json",
        success: function (data) {
          window.location.href = "/cart";
        },
        error: function (xhr, textStatus, errorThrown) {
          alert("Errore nell'aggiunta al carrello: " + xhr.responseText);
        }
      });
    })
    .catch(function (err) {
      console.error("Errore API:", err);
    });
  };

  addCartBtn.addEventListener("click", function () {
    addToCart();
  });

  // ================================
  // FUNZIONALITÀ "SCARICA PDF"
  // ================================
  // La funzione generatePDF ora:
  // 1. Carica il logo usando loadImageAsBase64
  // 2. Usa html2canvas (con opzione useCORS: true) per catturare il progetto
  // 3. Aggiunge l'intestazione (logo centrato), l'immagine del progetto e i dettagli testuali nel PDF

  // Crea dinamicamente un loader con spinner
function createPdfLoader() {
  var existing = document.getElementById('pdfLoader');
  if (existing) return existing;

  var loader = document.createElement('div');
  loader.id = 'pdfLoader';
  loader.style.position = 'fixed';
  loader.style.top = '0';
  loader.style.left = '0';
  loader.style.width = '100%';
  loader.style.height = '100%';
  loader.style.background = 'rgba(255, 255, 255, 0.9)';
  loader.style.zIndex = '9999';
  loader.style.display = 'flex';
  loader.style.alignItems = 'center';
  loader.style.justifyContent = 'center';
  loader.style.flexDirection = 'column';
  loader.innerHTML = `
    <div style="border: 8px solid #f3f3f3; border-top: 8px solid #CB1836; border-radius: 50%; width: 60px; height: 60px; animation: spin 1s linear infinite;"></div>
    <div style="margin-top: 20px; font-size: 18px; color: #333;">Generazione PDF...</div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;
  document.body.appendChild(loader);
  return loader;
}

// Funzione principale per creare il PDF
function generatePDF() {
  var loader = createPdfLoader();
  loader.style.display = 'flex';

  loadImageAsBase64("https://cdn.shopify.com/s/files/1/0325/3433/t/127/assets/intestazione_workshop.png?v=1743427636")
    .then(function (logoData) {
      html2canvas(document.getElementById("grid-wrapper"), { useCORS: true, allowTaint: false, scale: 1.2 })
        .then(function (canvas) {
          const { jsPDF } = window.jspdf;
          var pdf = new jsPDF('p', 'mm', 'a4');
          var pageWidth = pdf.internal.pageSize.getWidth();
          var pageHeight = pdf.internal.pageSize.getHeight();
          var margin = 10;

          var logoImg = new Image();
          logoImg.onload = function () {
            var logoRatio = logoImg.width / logoImg.height;
            var logoHeight = 30;
            var logoWidth = logoHeight * logoRatio;
            var logoX = (pageWidth - logoWidth) / 2;
            var logoY = margin;
            pdf.addImage(logoData, 'PNG', logoX, logoY, logoWidth, logoHeight);

            var currentY = logoY + logoHeight + 10;
            var pdfUsableWidth = pageWidth - margin * 2;
            var pdfUsableHeight = pageHeight - currentY - margin;
            var canvasWidth = canvas.width;
            var canvasHeight = canvas.height;
            var ratioCanvas = canvasWidth / canvasHeight;
            var drawWidth = pdfUsableWidth;
            var drawHeight = pdfUsableWidth / ratioCanvas;
            if (drawHeight > pdfUsableHeight) {
              drawHeight = pdfUsableHeight;
              drawWidth = pdfUsableHeight * ratioCanvas;
            }

            // 👉 Usa JPEG compresso per ridurre il peso
            var imgData = canvas.toDataURL('image/jpeg', 0.6);
            pdf.addImage(imgData, 'JPEG', margin, currentY, drawWidth, drawHeight);

            // Dati configuratore
            currentY = currentY + drawHeight + 10;
            var roomWidth = widthInput.value,
                roomLength = lengthInput.value,
                roomArea = (parseFloat(roomWidth) * parseFloat(roomLength)).toFixed(2),
                tileCounts = calculateTileCounts();
            var totalTiles = 0;
            for (var col in tileCounts) {
              if (tileCounts.hasOwnProperty(col)) { totalTiles += tileCounts[col]; }
            }
            var basePrice = totalTiles * 5;
            var discountRate = 0;
            if (totalTiles >= 1000) discountRate = 0.20;
            else if (totalTiles >= 500) discountRate = 0.15;
            else if (totalTiles >= 200) discountRate = 0.10;
            else if (totalTiles >= 100) discountRate = 0.05;
            var discountedPrice = basePrice * (1 - discountRate);
            var recommendedTiles = Math.ceil(totalTiles * 1.05);

            var textLines = [];
            textLines.push("Dettagli progetto:");
            textLines.push("Larghezza stanza (m): " + roomWidth);
            textLines.push("Lunghezza stanza (m): " + roomLength);
            textLines.push("Superficie stanza (m²): " + roomArea);
            textLines.push("");
            textLines.push("Piastrelle visualizzate per colore:");
            for (var color in tileCounts) {
              if (tileCounts.hasOwnProperty(color)) {
                textLines.push(color.toUpperCase() + ": " + tileCounts[color]);
              }
            }
            textLines.push("");
            textLines.push("Prezzo:");
            textLines.push("Prezzo base: €" + basePrice.toFixed(2));
            textLines.push("Sconto applicato: " + (discountRate * 100) + "%");
            textLines.push("Totale finale: €" + discountedPrice.toFixed(2));
            textLines.push("");
            textLines.push("Piastrelle consigliate (+5%): " + recommendedTiles);

            pdf.setFontSize(12);
            var lineHeight = 7;
            var currentTextY = currentY;
            for (var i = 0; i < textLines.length; i++) {
              if (currentTextY + lineHeight > pdf.internal.pageSize.getHeight() - margin) {
                pdf.addPage();
                currentTextY = margin;
              }
              pdf.text(textLines[i], margin, currentTextY);
              currentTextY += lineHeight;
            }

            loader.style.display = 'none'; // Nascondi loader
            pdf.save("progetto_piastrelle.pdf");
          };
          logoImg.src = logoData;
        });
    })
    .catch(function (err) {
      console.error("Errore durante la generazione del PDF:", err);
      loader.style.display = 'none'; // In caso di errore nasconde comunque
    });
}

if (downloadPdfBtn) {
  downloadPdfBtn.addEventListener("click", generatePDF);
} else {
  console.error("Bottone Scarica PDF non trovato!");
}


});
